<div [ngClass]="{ 'ap-list-item--has-action': hasAction(), 'ap-list-item--disabled': isDisabled() }" [attr.aria-disabled]="isDisabled()">
    @if (showTopBorder()) {
        <div class="ap-list-item__top-border"></div>
    }
    @switch (true) {
        @case (actionType() === 'accordion') {
            <ap-list-item-accordion (itemClicked)="onItemClicked()" [accordionOpen]="accordionOpen()">
                <ng-container *ngTemplateOutlet="ngContent"></ng-container>
                <ng-content accordion-content></ng-content>
            </ap-list-item-accordion>
        }
        @case (actionType() === 'action') {
            <ap-list-item-button (itemClicked)="onItemClicked()">
                <ng-container *ngTemplateOutlet="ngContent"></ng-container>
            </ap-list-item-button>
        }
        @case (actionType() === 'externalLink' || actionType() === 'internalLink') {
            <ap-list-item-link [actionType]="actionType()" (itemClicked)="onItemClicked()" [disabled]="disabled()">
                <ng-container *ngTemplateOutlet="ngContent"></ng-container>
            </ap-list-item-link>
        }
        @case (actionType() === 'switch') {
            <ap-list-item-switch [switchControl]="switchControl()" (itemClicked)="onItemClicked()" [disabled]="disabled()">
                <ng-container *ngTemplateOutlet="ngContent"></ng-container>
            </ap-list-item-switch>
        }
        @case (actionType() === 'none' || !actionType()) {
            <div>
                <ng-container *ngTemplateOutlet="ngContent"></ng-container>
            </div>
        }
    }
    @if (showBottomBorder()) {
        <div class="ap-list-item__bottom-border"></div>
    }
</div>

<ng-template #ngContent>
    <div class="ap-list-item__section">
        @if (!!ariaLabel()) {
            <span class="ap-sr-only">{{ ariaLabel() }}</span>
        }
        <div
            class="ap-list-item"
            [ngClass]="{
                'ap-list-item--noTopPadding': !!noTopPadding(),
                'ap-list-item--noBottomPadding': !!noBottomPadding()
            }"
            [attr.aria-hidden]="!!ariaLabel()"
        >
            @if (icon()) {
                <asn-icon class="ap-list-item__icon" [name]="icon()" size="medium" data-testid="list-item-icon"></asn-icon>
            }
            <div class="ap-list-item__middle-column">
                <div class="ap-list-item__middle-column__upper-row">
                    <div class="ap-list-item__title" [class.ap-list-item__title--bold]="isTitleBold()">
                        <span data-bb="list-item-title" [innerHtml]="title()"></span>
                        @if (badge()) {
                            <asn-badge>{{ badge() }}</asn-badge>
                        }
                    </div>
                    @if (tagContent() && value() === undefined && !subTitle()) {
                        <asn-tag [status]="tagStatus()" class="ap-list-item__tag" data-testid="list-item-tag">{{ tagContent() }}</asn-tag>
                    }
                    @if (value() !== undefined || switchControl()) {
                        <div class="ap-list-item__value" data-testid="list-item-value">
                            {{ value() }}
                        </div>
                    }
                </div>
                <div class="ap-list-item__middle-column__lower-row">
                    @if (subTitle()) {
                        <span class="ap-list-item__subtitle" [innerHtml]="subTitle()" data-testid="list-item-subtitle"></span>
                    }
                    @if (tagContent() && (value() !== undefined || subTitle())) {
                        <asn-tag [status]="tagStatus()" class="ap-list-item__tag" data-testid="list-item-tag">{{ tagContent() }}</asn-tag>
                    }
                    @if (percentage() !== undefined && (value() !== undefined || subTitle())) {
                        <div
                            data-testid="list-item-percentage"
                            class="ap-list-item__percentage"
                            [class.ap-list-item__percentage--plus]="plusOrMinusPercentage === 'plus'"
                            [class.ap-list-item__percentage--minus]="plusOrMinusPercentage === 'minus'"
                            [attr.data-bb]="'percentage' + plusOrMinusPercentage"
                        >
                            {{ percentage() > 0 ? '+' : '' }}{{ percentage() | number: '1.0-2' : 'nl-NL' }}%
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-template>
